module.exports = __webpack_public_path__ + "media/dorobek/assets/images/mnisw-5d4d9a840d32607f9c15340066dcc2f2.png";